export default function EditArtworkIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={`edit-artwork-icon ${className}`}
      onClick={onClick}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M425.02,165.23l-90.25-90.25c-2.57-2.57-5.97-3.98-9.6-3.98s-7.04,1.41-9.59,3.97l-230.6,230.59c-2.22,2.22-3.6,5.14-3.9,8.24l-10.01,100.27c-.41,4.07,1.02,8.06,3.91,10.95,2.57,2.58,5.96,3.99,9.57,3.99.42,0,.89-.03,1.44-.08l100.36-10.02c3.04-.34,5.91-1.71,8.1-3.9l230.57-230.58c2.57-2.56,3.98-5.96,3.98-9.59s-1.41-7.04-3.98-9.6ZM180.32,395.89l-84.65,8.43,8.44-84.65,157.05-157.04,76.21,76.21-157.05,157.05ZM354,222.23l-76.21-76.21,47.39-47.4,76.21,76.21-47.39,47.4Z"
      />
    </svg>
  );
}
